import React, { Fragment } from "react";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";

//import format from "date-fns/format";
import { convertUTCTimeToZonedTime } from "../../../../utils/utilFunc";

const ChallengeTimeline = ({ challenge }) => {
  return (
    <>
      <Typography variant="body1" color="textSecondary">
        This is an auto-generated timeline based on the dates the organization
        has entered.
      </Typography>
      <Box my={2}>
        <Timeline align="alternate">
          {challenge && challenge.registrationDeadlineDatetime && (
            <TimelineItem>
              <TimelineOppositeContent>
                <Typography variant="body1" color="textSecondary">
                  {
                    /* format(
                    new Date(challenge.registrationDeadlineDatetime),
                    "MMM d yyyy h:mm a O"
                  ) */
                    convertUTCTimeToZonedTime(
                      challenge.registrationDeadlineDatetime,
                      challenge.timeZone
                    )
                  }
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot color="primary" />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <Typography variant="body1" color="textSecondary">
                  Program Registration Deadline
                </Typography>
              </TimelineContent>
            </TimelineItem>
          )}
          {challenge &&
            challenge.round &&
            challenge.round.length > 0 &&
            challenge.round.map((round, index) => {
              return (
                <Fragment key={index}>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body1" color="textSecondary">
                        {round.startDatetime
                          ? convertUTCTimeToZonedTime(
                              round.startDatetime,
                              challenge.timeZone
                            )
                          : "N/A"}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color="primary" />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography variant="body1" color="textSecondary">
                        {round.name} Start Date
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Typography variant="body1" color="textSecondary">
                        {round.endDatetime
                          ? convertUTCTimeToZonedTime(
                              new Date(round.endDatetime),
                              challenge.timeZone
                            )
                          : "N/A"}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color="primary" />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography variant="body1" color="textSecondary">
                        {round.name} End Date
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  {round.lateSubmissionAllowed && (
                    <TimelineItem>
                      <TimelineOppositeContent>
                        <Typography variant="body1" color="textSecondary">
                          {round.lateSubmissionDateTime
                            ? convertUTCTimeToZonedTime(
                                new Date(round.lateSubmissionDateTime),
                                challenge.timeZone
                              )
                            : "N/A"}
                        </Typography>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot color="primary" />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>
                        <Typography variant="body1" color="textSecondary">
                          {round.name} Late Submission Date
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  )}
                </Fragment>
              );
            })}
        </Timeline>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => ({
  challenge: state.challenge.challenge,
});

export default connect(mapStateToProps)(ChallengeTimeline);
